import breadcrumbaccount from 'src/listeners/breadcrumb/account'
import breadcrumb from 'src/listeners/breadcrumb/index'
import nav from 'src/listeners/nav'

const listeners = [
  breadcrumbaccount,
  breadcrumb,
  nav,
]

export default listeners



// WEBPACK FOOTER //
// ./src/listeners.ts